import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthSessionService } from '../services/auth-session.service';

export const principalAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  if (!auth.hasPrincipalAccess()) return router.createUrlTree(['/teacher/dashboard']);

  return true;
};
